import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type initialStateProps = {
  userProfileEmailVerification: {
    status: string;
    emailId: string;
    companyId: string;
    source: string;
    errorCode: string;
  };
  companyProfileInformation: {
    companyName: string;
    orgType: string;
    street: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
  };

  authenticationScreen: boolean;
  companyInfoScreen: boolean;
  buyersListScreen: boolean;
  paymentDetailsScreen: boolean;
};

const initialState: initialStateProps = {
  userProfileEmailVerification: {
    status: "",
    emailId: "",
    companyId: "",
    source: "",
    errorCode: "",
  },
  companyProfileInformation: {
    companyName: "",
    orgType: "",
    street: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
  },

  authenticationScreen: true,
  companyInfoScreen: false,
  buyersListScreen: false,
  paymentDetailsScreen: false,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setUserProfileEmailVerificationData: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.userProfileEmailVerification = action.payload;
    },
    setCompanyProfileInfoData: (state, action: PayloadAction<any>) => {
      state.companyProfileInformation = action.payload;
    },

    setAuthenticationScreen: (state, action: PayloadAction<any>) => {
      state.authenticationScreen = action.payload;
    },
    setCompanyInfoScreen: (state, action: PayloadAction<any>) => {
      state.companyInfoScreen = action.payload;
    },
    setBuyersListScreen: (state, action: PayloadAction<any>) => {
      state.buyersListScreen = action.payload;
    },
    setPaymentDetailsScreen: (state, action: PayloadAction<any>) => {
      state.paymentDetailsScreen = action.payload;
    },
  },
});

export const {
  setUserProfileEmailVerificationData,
  setCompanyProfileInfoData,
  setAuthenticationScreen,
  setCompanyInfoScreen,
  setBuyersListScreen,
  setPaymentDetailsScreen,
} = profileSlice.actions;

export default profileSlice.reducer;
